export default "__VITE_PUBLIC_ASSET__070d6449__"